export default __webpack_public_path__ + "static/media/chevron-up.0f9ac6fe.svg";